var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.929.881a.875.875 0 0 1 1.237 0l7 7a.875.875 0 0 1 0 1.238l-7 7a.875.875 0 0 1-1.237-1.238l5.506-5.506H.881a.875.875 0 1 1 0-1.75h16.554l-5.506-5.506a.875.875 0 0 1 0-1.238",
    clipRule: "evenodd"
  })));
};
export default SvgArrow;